module.exports = __webpack_public_path__ + "img/big_cup.58ed9862.svg";